
import { Link } from 'react-router-dom';

const allServices = [
  { title: 'Medical Website Design', slug: 'medical-website-design', icon: 'ri-layout-line' },
  { title: 'Medical SEO & Local SEO', slug: 'medical-seo', icon: 'ri-search-line' },
  { title: 'Healthcare PPC Advertising', slug: 'healthcare-ppc', icon: 'ri-advertisement-line' },
  { title: 'Content Marketing', slug: 'content-marketing', icon: 'ri-article-line' },
  { title: 'Social Media Marketing', slug: 'social-media-marketing', icon: 'ri-instagram-line' },
  { title: 'Reputation Management', slug: 'reputation-management', icon: 'ri-star-line' },
  { title: 'Marketing Automation', slug: 'marketing-automation', icon: 'ri-robot-line' },
  { title: 'AI Lead Capture', slug: 'ai-lead-capture', icon: 'ri-customer-service-line' },
  { title: 'Analytics & Reporting', slug: 'analytics-reporting', icon: 'ri-bar-chart-box-line' }
];

interface RelatedServicesProps {
  currentSlug?: string;
  limit?: number;
}

export default function RelatedServices({ currentSlug, limit = 6 }: RelatedServicesProps) {
  const services = allServices.filter(s => s.slug !== currentSlug).slice(0, limit);

  return (
    <section className="py-20 px-6 lg:px-12 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.2em] text-[#7C3AED] font-bold mb-4">
            EXPLORE OUR SERVICES
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
            Other Healthcare Marketing Services
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/services/${service.slug}`}
              className="bg-white p-6 rounded-xl shadow-sm hover:shadow-lg transition-all border border-gray-100 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
              <span className="text-[#7C3AED] font-semibold text-sm flex items-center gap-1">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/#services"
            className="inline-flex items-center gap-2 text-[#7C3AED] font-semibold hover:underline"
          >
            View All Services <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
